export default {
  // 顶部工具栏
  projectArea: '项目区域',
  selectRegionPlaceholder: '请选择上级菜单',

  // 分屏模式
  singleScreen: '单分屏',
  quadScreen: '四分屏',
  nineScreen: '九分屏',

  // 加载状态
  loading: '正在努力加载...',

  // 播放器配置
  loadingText: '加载中',
  watermarkText: '直播流',

  // 质量选项
  qualityAdaptive: '自适应',
  qualitySmooth: '流畅',
  qualityStandard: '标准',
  qualityHD: '高清',
  qualityUHD: '超清',

  // 提示信息
  noVideoSource: '暂无视频源',
  selectDeviceFirst: '请先选择设备',
}
